export function getAdminMenu() {
  const canModuleDocuments = localStorage.getItem('canModuleDocuments') === 'true'
  const canModuleVacation = localStorage.getItem('canModuleVacation') === 'true'
  const menu = [
    {
      title: 'Fichar',
      route: 'journeyDay',
      icon: 'LogInIcon',
    },
    {
      title: 'Parte de horas',
      route: 'partes',
      icon: 'ClockIcon',
    },
    ...((canModuleVacation) ? [
      {
        title: 'Calendario',
        icon: 'CalendarIcon',
        route: 'vacations-calendar-admin',
      },
    ] : []),
    {
      title: 'Usuarios',
      route: 'users',
      icon: 'UsersIcon',
    },
    {
      title: 'Trazabilidad',
      route: 'traceabilities',
      icon: 'ActivityIcon',
    },
    ...((canModuleDocuments) ? [
      {
        title: 'Documentos',
        icon: 'FileTextIcon',
        children: [
          {
            title: 'Categorías',
            route: 'categoriesDocuments',
          },
          {
            title: 'Listado',
            route: 'adminDocuments',
          },
        ],
      },
    ] : []),
    ...((canModuleVacation) ? [
      {
        title: 'Ausencias',
        icon: 'BriefcaseIcon',
        children: [
          {
            title: 'Pendientes',
            route: 'vacations-admin',
          },
          {
            title: 'Mis solicitudes',
            route: 'vacations',
          },
        ],
      },
    ] : []),
    {
      title: 'Gestión',
      icon: 'SettingsIcon',
      children: [
        {
          title: 'Configuración',
          route: 'configuracion',
        },
        {
          title: 'Departamentos',
          route: 'departments',
        },
        {
          title: 'Política de registro horario',
          route: 'policy',
        },
      ],
    },
  ]
  return menu
}
